import React, { useState, useEffect, useRef } from 'react';
import validationAuth from '../../validationAuth';
import {
    Box, Grid, Typography, Paper, Avatar, Button, IconButton, Divider, TextField
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
//import EditIcon from '@mui/icons-material/Edit';
import iconEdit from '../../images/icon_edit.png';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useIsLoginState } from '../../components/IsLoginContext';
import * as common from '../../commons/common';
import AlertForConfirm from '../../components/alertForConfirm';
import leftArrowIcon from "../../images/left_arrow_icon.svg";

function PersonalPage() {
    const navigate = useNavigate();
    const { user, setIsLogin } = useIsLoginState();
    const [userData, setUserData] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [selectedImage, setSelectedImage] = useState(null);
    const [isLogoutAlertOpen, setIsLogoutAlertOpen] = useState(false);
    const [isSaveAlertOpen, setIsSaveAlertOpen] = useState(false);
    const fileInputRef = useRef();
    const [phoneError, setPhoneError] = useState("");

    // 사용자 정보 가져오기
    useEffect(() => {
        const fetchUserData = async () => {
            const memberId = localStorage.getItem('memberId');
            console.log(memberId)
            if (memberId) {
                try {
                    const url = `${common.getApiUrl()}/member/${memberId}`;
                    const accessToken = localStorage.getItem('access_token');
                    const response = await axios.get(url, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    });
                    setUserData(response.data);
                    setEditedData(response.data);
                    if (!response) {
                        if(window.confirm('오류가 발생하였습니다. 로그인 화면으로 이동합니다.')){
                            navigate('/', { replace: true });
                        } else {
                            navigate('/', { replace: true });
                        }
                    }
                } catch (error) {
                    common.handleApiError(error);
                }
            }
        };

        fetchUserData();
    }, []);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        // 전화번호 유효성 검사 추가
        if (editedData.phone) {
            if (!/^\d{11}$/.test(editedData.phone)) {
                setPhoneError("숫자 11자리를 입력해주세요.");
                return;
            }
        }

        setIsSaveAlertOpen(true);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditedData(userData);
        setSelectedImage(null);
    };

    const handleInputChange = (field) => (event) => {
        const value = event.target.value;

        // 휴대폰 번호 유효성 검사
        if (field === 'phone') {
            // 숫자만 입력 가능하도록 처리
            if (!/^\d*$/.test(value)) {
                setPhoneError("숫자만 입력해주세요.");
                return;
            }

            // 11자리 확인
            if (value.length > 0 && value.length !== 11) {
                setPhoneError("숫자 11자리를 입력해주세요.");
            } else {
                setPhoneError("");
            }
        }

        setEditedData({
            ...editedData,
            [field]: value
        });
    };

    const handleImageClick = () => {
        if (isEditing) {
            fileInputRef.current.click();
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(URL.createObjectURL(file));
            // 이미지 파일을 editedData에 추가
            setEditedData({
                ...editedData,
                profileImage: file
            });
        }
    };

    const handleSaveConfirm = async () => {
        setIsSaveAlertOpen(false);
        const accessToken = localStorage.getItem('access_token');

        try {
            const url = `${common.getApiUrl()}/member`;
            const modifiedMemeberRequest = {
                name: editedData.memberNm,
                phone: editedData.phone,
                email: editedData.email,
                imageId: userData.imageId || null
            };

            // 항상 FormData 형식으로 전송
            const formData = new FormData();
            formData.append('modifiedMemeberRequest', new Blob([JSON.stringify(modifiedMemeberRequest)], {
                type: 'application/json'
            }));

            // 새 이미지가 선택된 경우에만 파일 추가
            if (editedData.profileImage) {
                formData.append('uploadFile', editedData.profileImage);
            }

            // FormData로 전송
            await axios.put(url, formData, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            // 업데이트 후 사용자 정보 다시 가져오기
            const memberId = localStorage.getItem('memberId');
            const refreshUrl = `${common.getApiUrl()}/member/${memberId}`;
            const refreshResponse = await axios.get(refreshUrl, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (refreshResponse.data) {
                setUserData(refreshResponse.data);
                setEditedData(refreshResponse.data);
            }

            setIsEditing(false);
            alert('정보가 성공적으로 수정되었습니다.');
        } catch (error) {
            alert('정보 수정 중 오류가 발생했습니다.');
            console.error('Update error:', error);
        }
    };

    const handleLogoutClick = () => {
        setIsLogoutAlertOpen(true);
    };

    const handleClose = () => {
        setIsLogoutAlertOpen(false);
        setIsSaveAlertOpen(false);
    };

    // 로그아웃 처리 함수
    const handleLogout = async () => {
        setIsLogoutAlertOpen(false);
        const url = `${common.getApiUrl()}/auth/logout`;
        const accessToken = localStorage.getItem('access_token');

        try {
            await axios.post(url, {}, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            localStorage.clear();
            setIsLogin(false);
            navigate('/', { replace: true });
        } catch (error) {
            common.handleApiError(error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    // 필드 렌더링 함수
    const renderField = (label, value, field) => (
        <>
            <Grid container spacing={2} alignItems="center" sx={{ p: 1 }}>
                <Grid item xs={3}>
                    <Typography variant="body1" sx={{ fontSize: '0.8rem' }}>{label}</Typography>
                </Grid>
                <Grid item xs={9}>
                    {isEditing && ['memberNm', 'phone', 'email'].includes(field) ? (
                        <Box>
                            <TextField
                                fullWidth
                                value={editedData[field] || ''}
                                onChange={handleInputChange(field)}
                                variant="outlined"
                                size="small"
                                error={field === 'phone' && !!phoneError}
                            />
                            {field === 'phone' && phoneError && (
                                <Typography color="error" variant="caption">
                                    {phoneError}
                                </Typography>
                            )}
                        </Box>
                    ) : (
                        <Typography variant="body1" sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem'
                        }}>{value}</Typography>
                    )}
                </Grid>
            </Grid>
            <Divider sx={{ my: 1, borderBottomWidth: 1 }} />
        </>
    );

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: 'var(--main-white-color)',
        }}>
            {/* 상단헤더 */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                padding: '10px 20px',
                // backgroundColor: 'var(--sub-darkblue-color)',
                backgroundColor: 'var(--main-blue-color)',
                color: 'white',
                minHeight: 65,
                marginBottom: 0,
            }}>
                <Box sx={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    padding: '0 10px 0 4px'
                }} onClick={handleGoBack}>
                    <IconButton sx={{ padding: '4px 6px 4px 8px'}}>
                        <img src={leftArrowIcon} alt="뒤로가기" style={{ width: '15px', height: '15px' }} />
                    </IconButton>
                    <Typography sx={{ fontSize: '1.1rem', color: 'var(--main-blue-color)', paddingRight:'6px' }}>이전 </Typography>
                </Box>
                {!isEditing && (
                    <IconButton
                        onClick={handleEditClick}
                        sx={{
                            color: 'white',
                            position: 'absolute',
                            right: '20px',
                            padding: '8px',  // 클릭 영역 확장
                        }}
                    >
                        <img
                            src={iconEdit}
                            alt="edit"
                            style={{
                                width: '22px',
                                height: '22px',
                                objectFit: 'contain',
                                filter: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%) drop-shadow(0px 0px 1px #FFFFFF)', // 하얀색 그림자 추가하여 더 굵게 보이도록
                                WebkitFilter: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%) drop-shadow(0px 0px 1px #FFFFFF)',
                            }}
                        />
                    </IconButton>
                )}
            </Box>
            {/* 하단 박스 */}
            <Box sx={{
                marginTop: -1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                backgroundColor: 'var(--main-blue-color)',
                height: '155px',
                minHeight: '100px',
            }}>
                <Box
                    sx={{
                        position: 'relative',
                        cursor: isEditing ? 'pointer' : 'default',
                    }}
                    onClick={handleImageClick}
                >
                    <Avatar
                        sx={{
                            width: '7rem',
                            height: '7rem',
                            backgroundColor: 'var(--main-white-color)',
                            top: '-0.5rem'
                        }}
                        src={selectedImage || (userData && userData.imgSrc ? `${common.getImageBaseUrl()}${userData.imgSrc}` : '')}
                    />
                    {isEditing && (
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: 10,
                                right: -10,
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                padding: '4px',
                            }}
                        >
                            <CameraAltIcon sx={{ fontSize: 20, color: 'var(--main-blue-color)' }} />
                        </Box>
                    )}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        accept="image/*"
                        style={{ display: 'none' }}
                    />
                </Box>
                <Typography variant="body2" sx={{
                    fontSize: '1.2rem',
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginBottom:'2rem'
                }}>
                    {userData ? (isEditing ? editedData.memberNm : userData.memberNm) : ''} 님
                </Typography>
            </Box>

            <Box sx={{ p: 2, paddingTop:5, flexGrow: 1 }}>
                {userData ? (
                    <Paper sx={{ p: 2, mb: 2, boxShadow: 'none', borderRadius: '15px' }}>
                        {renderField('이름', userData.memberNm, 'memberNm')}
                        {renderField('휴대폰', userData.phone, 'phone')}
                        {renderField('이메일', userData.email || '', 'email')}
                        {renderField('소속',
                            `${userData.dept[0] ? userData.dept[0].deptNm : ''}
                             ${userData.dept[1] ? ` - ${userData.dept[1].deptNm}` : ''}
                             ${userData.dept[2] ? ` - ${userData.dept[2].deptNm}` : ''}`,
                            'dept'
                        )}
                        {renderField('직위', userData.position, 'position')}
                    </Paper>
                ) : (
                    <Box>정보가 없습니다.</Box>
                )}

                <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 6}}>
                    {isEditing ? (
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                onClick={handleSaveClick}
                                sx={{
                                    backgroundColor: 'var(--main-blue-color)',
                                    borderRadius: '50px',
                                    width: '10rem',
                                    height: '3rem',
                                    fontSize: '1.5rem',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        backgroundColor: 'var(--main-blue-color)',
                                        boxShadow: 'none',
                                    }
                                }}
                            >
                                저장
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={handleCancelEdit}
                                sx={{
                                    borderColor: 'var(--main-blue-color)',
                                    color: 'var(--main-blue-color)',
                                    borderRadius: '50px',
                                    width: '10rem',
                                    height: '3rem',
                                    fontSize: '1.5rem',
                                    boxShadow: 'none',
                                }}
                            >
                                취소
                            </Button>
                        </Box>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={handleLogoutClick}
                            sx={{
                                backgroundColor: 'var(--main-blue-color)',
                                borderRadius: '35px',
                                width: '14rem',
                                height: '4rem',
                                fontSize: '1.5rem',
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: 'var(--main-blue-color)',
                                    boxShadow: 'none',
                                }
                            }}
                        >
                            로그아웃
                        </Button>
                    )}
                </Grid>
            </Box>

            <AlertForConfirm
                open={isLogoutAlertOpen}
                onClose={handleClose}
                onConfirm={handleLogout}
                contentText="로그아웃 하시겠습니까?"
            />

            <AlertForConfirm
                open={isSaveAlertOpen}
                onClose={handleClose}
                onConfirm={handleSaveConfirm}
                contentText="변경사항을 저장하시겠습니까?"
            />
        </Box>
    );
}

export default validationAuth(PersonalPage);